import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinamritsar() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Amritsar',
    heading: 'Aaryan Travels: Corporate Cab Services in Amritsar',
    headingDescription: ' Aaryan Travels provides dependable Corporate Cab Services in Amritsar, designed for business executives, factory visitors, and corporate employees who require professional and punctual transportation. Whether you need daily staff commute, client pickups, airport transfers from Sri Guru Ram Dass Jee International Airport, or intercity travel for meetings and factory visits, our fleet of sedans, SUVs, and luxury vehicles ensures a smooth and comfortable ride. With trained chauffeurs, GPS-enabled cars, monthly billing options, and 24/7 support, we offer fully managed corporate transport solutions across Amritsar. From Ranjit Avenue to Industrial Area and Mall Road, Aaryan Travels is the trusted partner for corporate cab services in Amritsar.',

    top: 'Top Places to Visit in Amritsar with Aaryan Travels',

"topPlaces": [
  {
    "title": "Golden Temple (Harmandir Sahib)",
    "description": "The Golden Temple is the holiest pilgrimage site of Sikhism, known for its gold-plated sanctum floating peacefully in the middle of a sacred lake. Devotees from all over the world gather to listen to Gurbani hymns and experience divine serenity. The temple complex operates the world’s largest community kitchen, serving free meals to thousands daily. Its night illumination reflects beautifully in the water. The Golden Temple is Amritsar’s spiritual crown of harmony and devotion."
  },
  {
    "title": "Jallianwala Bagh",
    "description": "Jallianwala Bagh is a memorial dedicated to the victims of the 1919 massacre during British rule. The preserved bullet marks and Martyrs’ Well stand as powerful reminders of India’s struggle for freedom. A flame-shaped monument honors those who sacrificed their lives. The evening light-and-sound show narrates the tragic yet inspiring history. Jallianwala Bagh is Amritsar’s sacred ground of patriotism."
  },
  {
    "title": "Wagah Border Ceremony",
    "description": "The Wagah Border hosts the electrifying Beating Retreat Ceremony performed daily by Indian and Pakistani soldiers. Patriotic chants, synchronized drill marches, and flag-lowering rituals captivate audiences. The energy and unity in the crowd create an unforgettable atmosphere. It is one of the most thrilling military parades in the world. Wagah Border is Amritsar’s live symbol of national pride."
  },
  {
    "title": "Durgiana Temple",
    "description": "Durgiana Temple, also called the Silver Temple, resembles the architecture of the Golden Temple but is dedicated to Goddess Durga. Its sacred pond and gleaming silver doors add elegance to the divine setting. Devotees gather here during Navratri for grand celebrations. Lanterns and diyas reflect beautifully in the water during the evening. Durgiana Temple is Amritsar’s shining abode of devotion."
  },
  {
    "title": "Akal Takht",
    "description": "Akal Takht, located within the Golden Temple complex, is one of the five seats of Sikh authority established by Guru Hargobind Sahib. It represents spiritual strength combined with temporal power and justice. Devotees visit to seek blessings and witness traditional weapon displays. The structure stands as a symbol of courage and sovereignty. Akal Takht is Amritsar’s pillar of Sikh leadership."
  },
  {
    "title": "Gobindgarh Fort",
    "description": "Gobindgarh Fort is a historic military stronghold built by Maharaja Ranjit Singh. Today it is transformed into a cultural attraction featuring 7D shows, folk performances, camel rides, and traditional food courts. The light-and-sound show narrates Punjab’s glorious past. Visitors enjoy exploring its grand gates and bastions. Gobindgarh Fort is Amritsar’s celebration of royal valor."
  },
  {
    "title": "Partition Museum",
    "description": "The Partition Museum showcases real-life stories, photographs, and belongings of people affected by the 1947 partition of India. Emotional audio recordings and letters offer deep insight into their struggles and resilience. It is the world’s first museum dedicated to the history of partition. Visiting it is both moving and educational. Partition Museum is Amritsar’s archive of history and healing."
  },
  {
    "title": "Ram Bagh Gardens & Maharaja Ranjit Singh Museum",
    "description": "Ram Bagh Gardens is a serene green retreat once used by Maharaja Ranjit Singh as his summer palace. The onsite museum displays royal memorabilia, weapons, and paintings from the Sikh Empire. Fountains, sculptures, and tree-lined paths make it ideal for morning strolls. It beautifully blends history with nature. Ram Bagh is Amritsar’s regal botanical escape."
  },
  {
    "title": "Hall Bazaar",
    "description": "Hall Bazaar is one of the oldest shopping streets in Amritsar, famous for Phulkari embroidery, Punjabi juttis, spices, and handicrafts. The Mughal-style gateway at the entrance adds heritage charm. Street food stalls offer local delights like Amritsari kulcha, jalebi, and lassi. The market stays lively from morning till night. Hall Bazaar is Amritsar’s colorful shopping paradise."
  },
  {
    "title": "Khalsa College",
    "description": "Khalsa College is an architectural masterpiece built in Indo-Saracenic style in 1892. Its red sandstone façade, domes, and corridors resemble a royal palace. The vast campus is a popular spot for film shoots and photography. It holds historical significance in Punjab’s educational history. Khalsa College is Amritsar’s majestic blend of heritage and academia."
  }
],


"services": [
  {
    "name": "Corporate Cab Services in Amritsar",
    "description": "Our Corporate Cab Services in Amritsar are designed to meet the dynamic transportation needs of modern businesses. Whether you require daily pickups and drops for employees, cabs for executive travel, or vehicles for outstation client visits, we offer a well-managed fleet with professional chauffeurs. With features like monthly invoicing, centralized bookings, 24x7 availability, and real-time tracking, we ensure efficiency and peace of mind for HR and admin teams. Choose from sedans, SUVs, and premium cars, all maintained to deliver maximum comfort, punctuality, and safety."
  },
  {
    "name": "Amritsar Business Taxi",
    "description": "Amritsar Business Taxi is your reliable travel partner for corporate rides, executive meetings, and official travel. Our service ensures timely arrivals, discreet drivers, and clean, comfortable vehicles ideal for professional environments. Whether it's a one-time trip or a long-term plan, we tailor our services to suit business needs, offering consistent quality at competitive rates."
  },
  {
    "name": "Office Cab Amritsar",
    "description": "Our Office Cab service in Amritsar provides daily transportation for employees across locations. Whether you operate in industrial zones, commercial hubs, or remote offices, we offer route planning, shift-based scheduling, and real-time tracking for efficient transport management. Reduce employee fatigue, increase attendance, and ensure timely arrivals with our dependable office cab solutions."
  },
  {
    "name": "Chauffeur Driven Corporate Cab Amritsar",
    "description": "Experience professionalism and class with Chauffeur Driven Corporate Cab services in Amritsar. Our trained drivers follow strict etiquette and provide discreet, reliable service for executives, VIP clients, and business delegates. Choose from a range of premium vehicles that offer comfort, style, and a peaceful work environment while on the move."
  },
  {
    "name": "Monthly Corporate Cab Amritsar",
    "description": "Monthly Corporate Cab plans in Amritsar provide businesses with flexible and cost-effective solutions for their ongoing transportation requirements. Whether for employee commutes or executive travel, our monthly packages include vehicle assignment, fixed pricing, and priority support. Ideal for organizations looking for consistent service without daily booking hassles."
  },
  {
    "name": "Employee Transport Amritsar",
    "description": "Simplify your team’s commute with our Employee Transport services in Amritsar. We provide route-optimized pickup and drop solutions for staff across multiple shifts. With safety protocols, verified drivers, GPS-enabled vehicles, and punctual service, we ensure smooth operations for your business and satisfaction for your employees."
  },
  {
    "name": "Staff Cab Hire Amritsar",
    "description": "Staff Cab Hire in Amritsar is perfect for companies that need dependable transportation for field teams, warehouse employees, or office staff. We offer flexible vehicle options, including hatchbacks, sedans, and MUVs, all operated by trained drivers. Get route planning, usage tracking, and transparent billing customized for your workforce needs."
  },
  {
    "name": "Affordable Business Cab Amritsar",
    "description": "Affordable Business Cab Amritsar gives companies budget-friendly cab solutions without compromising quality. Ideal for startups, SMEs, and enterprises looking to optimize travel costs, our service ensures timely travel, professional chauffeurs, and clean, well-maintained vehicles for all business mobility needs within and around Amritsar."
  },
  {
    "name": "Executive Taxi Amritsar",
    "description": "Executive Taxi Amritsar offers premium travel options for top-tier professionals. Choose from luxury sedans and SUVs, perfect for board members, visiting clients, or high-ranking executives. With leather seats, Wi-Fi, bottled water, and courteous drivers, we ensure a first-class travel experience backed by punctual service."
  },
  {
    "name": "Corporate Sedan Rental Amritsar",
    "description": "Corporate Sedan Rental in Amritsar is ideal for daily office commutes, airport pickups, and inter-city meetings. Our air-conditioned sedans are perfect for two to four passengers, offering comfort, safety, and efficiency. Flexible rental options available by the hour, day, or month, with or without chauffeur."
  },
  {
    "name": "Amritsar Company Taxi",
    "description": "Amritsar Company Taxi service provides dedicated cab solutions for businesses across sectors. Whether it’s client visits, team events, or regular transport, our company-focused approach ensures timely service, professional drivers, and fleet flexibility. Integrate with your company’s travel desk for seamless coordination and billing."
  },
  {
    "name": "Best Corporate Cab Amritsar",
    "description": "Recognized for quality and reliability, our Best Corporate Cab service in Amritsar offers unmatched standards in safety, punctuality, and professionalism. Suitable for organizations of all sizes, we provide tailored packages with well-maintained vehicles and courteous chauffeurs who understand business etiquette."
  },
  {
    "name": "Online Cab Booking Amritsar",
    "description": "With Online Cab Booking for corporates in Amritsar, you can manage all your business travel needs from one centralized platform. Schedule rides, track usage, receive invoices, and access historical data with ease. Perfect for travel managers, admin heads, and employees who require a fast, reliable booking solution."
  },
  {
    "name": "Premium Office Cab Amritsar",
    "description": "Upgrade your office transport with Premium Office Cab services in Amritsar. Featuring top-quality vehicles and priority service, this option is ideal for businesses that prioritize employee comfort and executive-class travel. Great for senior management, important guest visits, or company leadership travel."
  },
  {
    "name": "Corporate Shuttle Amritsar",
    "description": "Corporate Shuttle services in Amritsar provide efficient transportation for large teams or groups. Ideal for tech parks, industrial units, and corporate campuses, we offer mini-buses, tempo travelers, and large MUVs with scheduled routes and trained drivers. Enhance productivity with stress-free, on-time group transport."
  }
],
"tableData": [
  ["Corporate Cab Services in Amritsar", "Amritsar Business Taxi"],
  ["Office Cab Amritsar", "Chauffeur Driven Corporate Cab Amritsar"],
  ["Monthly Corporate Cab Amritsar", "Employee Transport Amritsar"],
  ["Staff Cab Hire Amritsar", "Affordable Business Cab Amritsar"],
  ["Executive Taxi Amritsar", "Corporate Sedan Rental Amritsar"],
  ["Amritsar Company Taxi", "Best Corporate Cab Amritsar"],
  ["Online Cab Booking Amritsar", "Premium Office Cab Amritsar"],
  ["Corporate Shuttle Amritsar", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Corporate Cab Services in Amritsar",
    "WhyChoosedescription": "Aaryan Travels offers professional and reliable corporate cab services tailored to businesses in Amritsar."
  },
  {
    "WhyChooseheading": "Punctual Pickup and Drop for Seamless Commutes",
    "WhyChoosedescription": "Ensure timely and hassle-free transportation for your employees and clients across Amritsar."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Business Travel",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained for your comfort and professionalism."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Amritsar’s Business Routes",
    "WhyChoosedescription": "Our drivers know the city well, ensuring efficient and smooth navigation through key corporate areas."
  },
  {
    "WhyChooseheading": "Transparent Billing and No Hidden Charges",
    "WhyChoosedescription": "Enjoy GST-compliant invoices and upfront pricing to simplify your corporate expense management."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support for Corporate Clients",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, modifications, and queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans to Suit Your Business Needs",
    "WhyChoosedescription": "Choose from daily, weekly, or monthly cab hire contracts customized to your organization’s requirements."
  },
  {
    "WhyChooseheading": "Wide Fleet of Vehicles for Corporate Travel",
    "WhyChoosedescription": "Select from sedans, SUVs, and tempo travellers based on your team size and travel preferences."
  }
]
































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab services in Amritsar?',
    answer: 'Yes, Aaryan Travels provides professional and dependable corporate cab services throughout Amritsar for all business travel needs.',
  },
  {
    question: 'How can I book corporate cab services in Amritsar with Aaryan Travels?',
    answer: 'You can book corporate cabs through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Amritsar?',
    answer: 'Aaryan Travels offers a wide range of vehicles including sedans, SUVs, and premium cars suitable for executive and employee transportation.',
  },
  {
    question: 'Are Aaryan Travels’ corporate cab services suitable for daily employee commute in Amritsar?',
    answer: 'Yes, we provide customized corporate cab solutions for daily employee pickups and drops across Amritsar.',
  },
  {
    question: 'Are your drivers trained and experienced for corporate travel requirements in Amritsar?',
    answer: 'Absolutely. Our drivers are professional, courteous, and well-versed with corporate travel standards in Amritsar.',
  },
  {
    question: 'Can Aaryan Travels manage bulk or group cab bookings for corporate events in Amritsar?',
    answer: 'Yes, we specialize in handling group transportation and bulk cab bookings for corporate meetings, conferences, and events.',
  },
  {
    question: 'Do you offer monthly billing or invoicing options for corporate cab services in Amritsar?',
    answer: 'Yes, Aaryan Travels provides flexible billing options including monthly invoicing for our corporate clients.',
  },
  {
    question: 'Is your corporate cab service in Amritsar available 24x7?',
    answer: 'Yes, we offer round-the-clock corporate cab services to ensure seamless business travel at any time.',
  },
  {
    question: 'What safety and hygiene protocols are followed for corporate cab services in Amritsar?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety measures to protect passengers.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate cab bookings in Amritsar?',
    answer: 'Yes, you can specify preferred pickup and drop points as per your corporate travel plans.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Gurpreet Singh',
    feedback: 'Aaryan Travels’ corporate cab service in Amritsar has been exceptional. Professional drivers and timely service always.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Simran Kaur',
    feedback: 'Reliable and efficient corporate cab service in Amritsar. Our company trusts Aaryan Travels for all corporate travel needs.',
    rating: 5,
  },
];





























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Amritsar",
  "image": "https://aaryantravels.com/assets/images/corporate-cab-amritsar.jpg", // replace with actual image URL
  "description": "Professional and affordable corporate cab services in Amritsar by Aaryan Travels. Perfect for business travel, employee transport, and office commute with premium sedans and SUVs.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.5",  // example rating, update if needed
    "ratingCount": "1200", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/corporate-cab-services-amritsar"
  }
};




  return (
    <div>


<Helmet>
  <title>Corporate Cab Services in Amritsar | Business Taxi & Employee Transport | Aaryan Travels</title>
  <meta
    name="description"
    content="Professional and affordable corporate cab services in Amritsar by Aaryan Travels. Perfect for business travel, employee transport, and office commute with premium sedans and SUVs."
  />
  <meta
    name="keywords"
    content="Corporate Cab Services in Amritsar, Amritsar Business Taxi, Office Cab Amritsar, Chauffeur Driven Corporate Cab Amritsar, Monthly Corporate Cab Amritsar, Employee Transport Amritsar, Staff Cab Hire Amritsar, Affordable Business Cab Amritsar, Executive Taxi Amritsar, Corporate Sedan Rental Amritsar, Amritsar Company Taxi, Best Corporate Cab Amritsar, Online Cab Booking Amritsar, Premium Office Cab Amritsar, Corporate Shuttle Amritsar"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/33.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinamritsar;